<template>
  <div class="mv-mdh">
    
    <h5 class="d-lg-none text-center"> <b class="red"> MILLION DOLLAR HABITS </b> </h5><br>
    <cqtextimagesection direction = "R" :imagesrc="images.mdhdemo" showTLRBorder="true">
        
        <h5 class="d-none d-lg-block"> <b class="red"> MILLION DOLLAR HABITS </b> </h5><br>
        <cq-paratext> To give you a first hand experience of the habits you need to develop to take your life to the next level, Manan Vasa has designed a power packed <b class="red"> LIVE DEMONSTARTION </b> where he shows you what you need to do to translate <b class="red"> Any-One-Personal-Goal </b> into Reality in a time-bound manner. </cq-paratext>
        <cq-paratext> During this <b class="red"> 3 hour </b> immersive engagement, you will be introduced to the laws of productivity and sensitized to the power of <b class="red"> implementation </b> in realizing any goal. </cq-paratext>
        <cq-paratext> You will discover the missing steps in achieving your goals by deploying his Proprietary <b class="red"> Make It Happen Framework&copy;. </b> </cq-paratext>
        <cq-btn class="text-center pb-4">BOOK A SEAT NOW</cq-btn>
        
    </cqtextimagesection>
  </div>
</template>

<script>

import CQPara from '../../components/ui/CQPara.vue'
import CQButton from '../../components/ui/CQButton.vue'
import CQTextImageSection from '../../components/ui/CQTextImageSection.vue'

// Import Image
import mdhdemo from '../../assets/image/mv/mdhdemo.png'

export default {
    components:{
        
        'cq-paratext' : CQPara,
        'cq-btn' : CQButton,
        'cqtextimagesection': CQTextImageSection,
    },
    data() {
    return {
        images: { 
            mdhdemo,
        }
    }
  }

}
</script>

<style scoped>
  .mv-mdh >>> .red{
    color: var(--primary-color);
    font-size: 20px;
  }

  .mv-mdh >>> h5{
    font-family: 'Seravek-Medium'; 
    font-size: 20px;
  }

@media only screen and (min-width: 992px){
  .mv-mdh >>> .gg2 {
    padding-right: 104.5px !important;
    padding-top: 25px;
  }

  .mv-mdh >>> .tgg-img{
    min-width: 100%;
  }
}
</style>